import Axios from '@/axios'

// 查询鱼住门店
// 接口权限名：web:yzStore:index
export const QueryShopIndex = data => {
  return Axios({
    url: `/device-manager/web-api/yz-store/index`,
    method: 'POST',
    type: 'json',
    data
  })
}

// 创建鱼住门店
// 接口权限名：web:yzStore:create
export const ShopCreate = data => {
  return Axios({
    url: `/device-manager/web-api/yz-store/create`,
    method: 'POST',
    type: 'json',
    data
  })
}

// 修改鱼住门店
// 接口权限名：web:yzStore:update
export const ShopUpdate = data => {
  return Axios({
    url: `/device-manager/web-api/yz-store/update/${data.id}`,
    method: 'POST',
    type: 'json',
    data
  })
}

// 删除店铺
// 接口权限名：web:store:delete
export const ShopDelete = id => {
  return Axios({
    url: `/device-manager/web-api/store/delete/${id}`,
    method: 'POST',
    type: 'json'
  })
}

// 关闭门店
// 接口权限名：web:store:close
export const ShopClose = id => {
  return Axios({
    url: `/device-manager/web-api/store/close/${id}`,
    method: 'POST',
    type: 'json'
  })
}

// 更新支付宝门店状态
// 接口权限名：web:store:updateZfbShopState
export const ShopUpdateZFBState = id => {
  return Axios({
    url: `/device-manager/web-api/zfb-store/update_order_status/${id}`,
    method: 'POST',
    type: 'json'
  })
}
